import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@material-ui/core";
import { useMemo } from "react";
import { Controller, DeepPartial, useForm } from "react-hook-form";
import { PrimaryButton } from "../../../components/button";
import { Country } from "../../../components/forms/country";
import { TextField } from "../../../components/forms/text";
import { UsersDTO } from "../../../store/users/models/dto";

type CreateMerchant = UsersDTO.Requests.Merchant.Create.T;

export function NewMerchant({
  onSubmit,
}: {
  onSubmit: (x: CreateMerchant) => Promise<any>;
}) {
  const schema = UsersDTO.Requests.Merchant.Create.useField();

  const defaultValues: DeepPartial<CreateMerchant> = useMemo(
    () => ({
      products: [],
      apiUser: true,
    }),
    []
  );

  const { handleSubmit, control } = useForm<CreateMerchant>({
    resolver: yupResolver(schema),
    defaultValues,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="name"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="Name"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="emailAddress"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="E-mail"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="nationality"
            render={({ field, fieldState: { error } }) => (
              <Country
                fullWidth
                label="Country"
                {...field}
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <PrimaryButton type="submit">Create</PrimaryButton>
        </Grid>
      </Grid>
    </form>
  );
}
